import PlaylistService from "./playlist-service";
import ToastService from "./toast-service";
import PlayerManager from "./player-manager";

// TODO : check if entered room
const playPlaylist = async ({ id, name }) => {
  ToastService.infoToast(`playing ${name}`);
  const playlist = await PlaylistService.getPlaylist({
    id,
  });
  const { songs } = playlist;
  if (songs && songs.length > 0) PlayerManager.playAll(songs);
  else ToastService.errorToast("cannot play empty playlist");
};

// to play a single song pass queue:[song]
const playSong = ({ queue, idx }) => {
  PlayerManager.playAll(queue, idx);
};

const addToQueue = async ({ songs, playlistId }) => {
  if (songs) {
    PlayerManager.addToQueue(songs);
  } else {
    const playlist = await PlaylistService.getPlaylist({
      id: playlistId,
    });
    PlayerManager.addToQueue(playlist.songs);
  }
  ToastService.infoToast("queue modified");
};

const changePlaylistTheme = async ({ id, song }) => {
  const { thumbnails } = song;
  const thumbnail =
    thumbnails && (thumbnails.mediumUrl || thumbnails.standardUrl);
  if (!thumbnail) return false;
  const done = await PlaylistService.editPlaylist({
    id,
    thumbnail,
  });
  return done;
};

export { playPlaylist, playSong, addToQueue, changePlaylistTheme };
